import React from 'react';
import { retryLoading } from '~/util';
import { getRoutePermissions } from '~/modules/common/permissions';

const QuickAllocation = React.lazy(() =>
  retryLoading(() => import('./QuickAllocation'))
);

const route = ({ intl, me }) => {
  const { canViewQuickAllocation } = getRoutePermissions(me);
  const {
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled },
    permissions
  } = me;

  return {
    path: '/quick-allocation',
    icon: () => null,
    isSideBarRoute: false,
    component: QuickAllocation,
    hidden: true,
    title: () => intl.formatMessage({ id: 'routes.quickAllocation' }),
    showDivider: true,
    hasPermission: !isPsaRmpEnhancedProjectManagerPersonaEnabled
      ? Boolean(
          permissions.find(
            p =>
              (p.permissionActionUri === 'urn:replicon:user-action:view-user' &&
                p.dataAccessLevelUris.includes(
                  'urn:replicon:user-data-access-level:resource-manager'
                )) ||
              (p.permissionActionUri === 'urn:replicon:user-action:view-user' &&
                p.dataAccessLevelUris.includes(
                  'urn:replicon:user-data-access-level:resource-pool-manager'
                ))
          )
        )
      : canViewQuickAllocation
  };
};

export default route;
